import Overview from "./Overview.vue";

export default [
  {
    path: "/overview",
    component: Overview,
  },
];
